import { z } from "zod";
import { ImageMediaSchema } from "../Media";
import { ActionSchema } from "../Actions";
export const LogoSchema = z.object({
    image: ImageMediaSchema.optional(),
    action: ActionSchema.optional(),
});
//# sourceMappingURL=index.js.map